import { Component, ViewChild } from '@angular/core';
import { RecaptchaModule } from 'ng-recaptcha';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [RecaptchaModule, ReactiveFormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {
    this.forgotForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }
  forgotForm: FormGroup;
  email: string = '';
  captchaVerified: boolean = false;
  captchaToken: string | null = null;
  @ViewChild('captchaRef') captchaRef: any;
  showSuccess: boolean = false;
  onCaptchaResolved(token: string | null) {
    if (token) {
      // Replace with your API endpoint
      const apiUrl = environment.apiUrl + 'api/v1/validate_recaptcha/';
      this.http.post(apiUrl, { 'g-recaptcha-response': token }).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.captchaVerified = true;
            this.toastr.success(res.message);
          } else {
            this.captchaVerified = false;
            this.captchaRef.reset(); // Reset the captcha
            this.toastr.error('Captcha verification failed. Please try again.');
          }
          console.log('Captcha verification response:', res);
        },
        error: (err) => {
          this.captchaVerified = false;
          this.toastr.error('Captcha verification failed. Please try again.');
          console.error('Captcha verification failed:', err);
        },
      });
    }
  }
  formErrorType: string | null = null;

  sendResetLink() {
    if (this.forgotForm.invalid) {
      this.formErrorType = 'invalid';
      this.forgotForm.markAllAsTouched();
      return;
    }
    this.formErrorType = null;
    this.email = this.forgotForm.value.email; // Set email for success message

    const emailControl = this.forgotForm.get('email');
    const apiUrl = environment.apiUrl + 'api/v1/reset_password_send_link/';
    this.http.post(apiUrl, { email: emailControl?.value }).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.showSuccess = true;
          this.toastr.success(res.message);
        } else {
          this.showSuccess = false;
          this.toastr.error(
            res.message || 'Failed to send reset link. Please try again.'
          );
        }
      },
      error: (err) => {
        this.showSuccess = false;
        this.toastr.error(
          err.message || 'Failed to send reset link. Please try again.'
        );
        console.error('email failed:', err);
      },
    });
  }
}
